import RfiInfoNameEdit from './RfiInfoNameEdit.component';

export default RfiInfoNameEdit;
